import { type CategorizedSections } from './categorizeSection'
import { SectionList } from './SectionList'

interface DayCardContentProps {
  id: string
  categorizedSections: CategorizedSections
}

export function DayCardContent({
  id,
  categorizedSections,
}: DayCardContentProps) {
  return (
    <div className="space-y-4">
      {categorizedSections.mainBusiness.length > 0 && (
        <div>
          <h3 className="text-sm font-semibold">Main Business:</h3>
          <SectionList sections={categorizedSections.mainBusiness} day={id} />
        </div>
      )}
      {categorizedSections.oralQuestions.length > 0 && (
        <div>
          <h3 className="text-sm font-semibold">Oral Questions:</h3>
          <SectionList sections={categorizedSections.oralQuestions} day={id} />
        </div>
      )}
      {categorizedSections.statementsAndUrgentQuestions.length > 0 && (
        <div>
          <h3 className="text-sm font-semibold">
            Statements and Urgent Questions:
          </h3>
          <SectionList
            sections={categorizedSections.statementsAndUrgentQuestions}
            day={id}
          />
        </div>
      )}
      {categorizedSections.adjournmentDebate.length > 0 && (
        <div>
          <h3 className="text-sm font-semibold">Adjournment Debate:</h3>
          <SectionList
            sections={categorizedSections.adjournmentDebate}
            day={id}
          />
        </div>
      )}
    </div>
  )
}
